import { render, staticRenderFns } from "./LaporanOmzetSc.vue?vue&type=template&id=15a4cbda&"
import script from "./LaporanOmzetSc.vue?vue&type=script&lang=js&"
export * from "./LaporanOmzetSc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports